$(document).ready(function () {
    $('br').attr('aria-hidden', 'true');
});

//Accessible  Header query third party links
$(document).ready(function () {

  $('a').each(function () {

    var text = $.trim($(this).text()).toLowerCase();

    if (text === 'applied nutrition' || text === 'affiliate program') {

      $(this).attr({
        target: '_blank',
        rel: 'noopener noreferrer',
        'aria-label': $.trim($(this).text()) + ' Redirecting to a third-party website, opens in a new tab'
      });
    }
  });
});
// product page gallery prev and next Button
$(document).on('click', 'slider-component.thumbnail-slider .slider-button--prev, slider-component.thumbnail-slider .slider-button--next', function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  var $button = $(this);
  var $sliderComponent = $button.closest('slider-component.thumbnail-slider');
  var $thumbnailList = $sliderComponent.find('.thumbnail-list').first();
  var $slides = $thumbnailList.find('.thumbnail-list__item:visible');
  if (!$slides.length) return;
  var currentIndex = $slides.index($slides.find('button[aria-current="true"]').closest('.thumbnail-list__item'));
  if (currentIndex < 0) {
    currentIndex = 0;
  }
  var newIndex = currentIndex;
  if ($button.hasClass('slider-button--next')) {
    newIndex = currentIndex + 1;
  } else {
    newIndex = currentIndex - 1;
  }

  if (newIndex < 0) {
    newIndex = 0;
  }

  if (newIndex >= $slides.length) {
    newIndex = $slides.length - 1;
  }
  var $targetSlide = $slides.eq(newIndex);
  var $targetButton = $targetSlide.find('button.thumbnail').first();
  if ($targetButton.length) {
    $targetButton.trigger('click');
    $targetButton.focus();
    $thumbnailList.animate(
      {
        scrollLeft: $targetSlide.position().left + $thumbnailList.scrollLeft() - 20
      },
      300
    );
  }
});
// price label on product page query
$(function () {
  var $price = $('#price-template--19897262571638__main .price__regular .price-item--regular');

  if ($price.length) {
    var priceText = $price.text().replace(/Regular price|Sale price/gi, '').trim();

    $price.attr('aria-hidden', 'true');
    $price.before('<span class="visually-hidden">Regular price ' + priceText + '</span>');
  }
});
// for success message on contact form
$(function () {
  $('#ContactForm button[type="submit"]').attr('aria-label', 'submit, on successful submission the page will refresh and focous will move to the top of page');

  $('#ContactForm').on('submit', function (e) {
    var $firstEmpty = $();

    $('#ContactForm input[required], #ContactForm textarea[required], #ContactForm select[required]').each(function () {
      var $field = $(this);
      $field.removeAttr('aria-invalid');

      if (!$.trim($field.val()) && !$firstEmpty.length) {
        $firstEmpty = $field;
      }
    });
    if ($firstEmpty.length) {
      e.preventDefault();
      $firstEmpty.attr('aria-invalid', 'true').focus();
      return false;
    }
  });
});
$(document).ready(function () {
  var slideSelector = ".ai-slideshow-slide-aqi85czfrd3o2d2zinaigenblock96b0481r433h4";
  var prevBtn = ".ai-slideshow-prev-aqi85czfrd3o2d2zinaigenblock96b0481r433h4";
  var nextBtn = ".ai-slideshow-next-aqi85czfrd3o2d2zinaigenblock96b0481r433h4";
  function updateSliderA11y() {
    $(slideSelector).each(function () {
      var $slide = $(this);
      var isActive = $slide.hasClass("active");
      var altText = $slide.find("img").first().attr("alt") || "";

      if (isActive) {
        $slide.attr({
          "aria-hidden": "false",
          "tabindex": "0",
          "role": "img",
          "aria-label": altText
        });
      } else {
        $slide.attr({
          "aria-hidden": "true",
          "tabindex": "-1"
        }).removeAttr("role aria-label");
      }

      $slide.find("img").attr("aria-hidden", "true");
    });
  }
  updateSliderA11y();
  $(document).on("click", prevBtn + "," + nextBtn, function () {
    setTimeout(function () {
      updateSliderA11y();

      var $activeSlide = $(slideSelector + ".active");

      if ($activeSlide.length) {
        $activeSlide.focus();
      }
    }, 600);
  });
});

